import {  Grid } from '@mui/material';
import { useCustomContext } from './ContextHook';



export default function ResponseWrapper({ children }: { children: JSX.Element }) {
    const context = useCustomContext()
  
    return (
        <Grid container justifyContent="center" className="response-container" >
            <Grid style={{padding: '30px', borderRadius: '20px', backgroundColor: '#FFFFFF', color: '#272525'}} item xs={context.width < 786 ? 10 : 5}>
                {children}
            </Grid>
        </Grid>
    );
}
